
export default [
  {
    path: '/admin/content-managements',
    name: 'content-management',
    meta: { requiresAuth: true },
    component: () => import('@/pages/administrator/content-management')
  },
  {
    path: '/admin/content-managements/create',
    name: 'content-management-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/administrator/content-management/create.vue')
  },
  {
    path: '/admin/content-managements/:id/eidt',
    name: 'content-management-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/administrator/content-management/edit.vue')
  }
]
